"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserWithdrawStatus = void 0;
/**
 * 사용자 탈퇴 상태
 */
exports.UserWithdrawStatus = {
    /**
     * 정상
     */
    ACTIVE: "ACTIVE",
    /**
     * 탈퇴를 요청했으나, 재가입이 가능한 상태
     */
    REJOINABLE: "REJOINABLE",
    /**
     * 탈퇴됨
     */
    WITHDRAWN: "WITHDRAWN",
};
